import {
    AssertUtils,
    GoingUtils,
    ArrayUtils,
    QueryCommand,
    Record,
    DateFun
} from "goingutils";
import GoingPagin from "./goingPagin";
import GridSettingPanel from "./gridSettingPanel";
import dhtmlXGridObject from '../dhtmlXGridObject';
import dropCodingFactory from "../../../../../common/dropCodingFactory";

var colWidthMapping = {
    smallest: 50,
    small: 80,
    medium: 140,
    big: 300,
    "*": 90
};

dhtmlXGridObject.prototype._initColWidthAgain = function () {
    this.__changeFileAryWidth(this.fieldAry, this);
    let myGrid = this;

    this.fieldAry.forEach(function (item) {
        let newWidth = myGrid._getColWidth(item);
        if (AssertUtils.isNotEmpty(newWidth)) {
            myGrid.setColWidth(
                myGrid.getColIndexByField(item.id),
                parseFloat(newWidth)
            );
        }
    });
};
//  对列宽进行换算
dhtmlXGridObject.prototype._getColWidth = function (cm) {
    cm.oldWidth = cm.width;
    var thWidth = null;
    var p = this;
    var gridId = p.gridId;
    var tBodyWid = $("#" + gridId).width();
    //  如果存在选 列
    if (this.colSelBox) {
        tBodyWid = parseFloat(tBodyWid + "") - 40;
    }
    //    如果存在序号列
    if (this.colOrderNum) {
        tBodyWid = parseFloat(tBodyWid + "") - 50;
    }
    if (p.autoGrid) {
        if (!p.hasScrollerFlag) {
            if (!AssertUtils.isNotNull(cm.width) || !AssertUtils.isNumber(cm.width)) {
                cm.width = 90;
            }
            var _W =
                (parseFloat(tBodyWid + "") * parseInt(cm.width)) / p.summaryWidth;
            cm.width = _W-2;
            thWidth = cm.width;
        } else {
            //如果出现滚动条 则返回用户定义的宽度即可
            thWidth = cm.width;
        }
    } else {
        //判断是否存在%号
        if (cm.width) {
            var ddd = cm.width + "";
            if (ddd.indexOf("%") > -1) {
                cm.width = (parseFloat(tBodyWid + "") * parseInt(ddd)) / 100;
            }
            thWidth = cm.width;
        }
    }
    return thWidth;
};
//计算列的宽度  判断是否需要滚动条
dhtmlXGridObject.prototype.__changeFileAryWidth = function (
    fieldAry,
    myGrid
) {
    var gridId = myGrid.gridId;
    var tBodyWid = $("#" + gridId).width();

    var widthSummary = 0;
    for (let jj = 0; jj < fieldAry.length; jj++) {
        let cm = fieldAry[jj];
        if (AssertUtils.isNotEmpty(cm.oldWidth)) {
            cm.width = cm.oldWidth;
        }
        //      如果列隐藏则不需要计算
        if (cm.hidden != true) {
            //如果传入的是宽度类型
            if (AssertUtils.isNotEmpty(cm.width) && !AssertUtils.isNumber(cm.width)) {
                cm.width = (colWidthMapping)[cm.width];
            } else if (AssertUtils.isNotEmpty(cm.width)) {
                cm.width = parseFloat(cm.width);
            } else {
                cm.width = 90;
            }
            if (!AssertUtils.isNumber(cm.width)) {
                cm.width = 90;
            }
            widthSummary = parseFloat(widthSummary + "") + parseFloat(cm.width);
        }
    }
    myGrid.summaryWidth = widthSummary;
    //如果总宽度大于了 table的宽度 则出现滚动条 如果不大于table的宽度 则不出现滚动条
    if (widthSummary > parseFloat(tBodyWid + "")) {
        myGrid.hasScrollerFlag = true;
    } else {
        myGrid.hasScrollerFlag = false;
    }
};

//初始化表格系统参数
dhtmlXGridObject.prototype.initSysProp = function () {

};

//初始化表格控件的部分初始值
dhtmlXGridObject.prototype.initGridProp = function ({
                                                        moreSel,
                                                        _pageSize = GoingUtils.pageSizeNumber,
                                                        colOrderNum = true,
                                                        colSelBox = false, selectRelCheck = true,
                                                    }) {
    //默认展示表格第一页数据
    this.curPage = 1;
    this.selectRelCheck = selectRelCheck;
    //设置每页查询的记录数
    this.curPageSize = _pageSize;
    if (!this.hasPagin) {
        this.curPageSize = GoingUtils.maxPageSize;
    }
    //是否选择表格序号列
    this.colOrderNum = colOrderNum;
    this.urlMaping = {};
    this.codingMappingObj = {};
    // 是否显示显示列
    this.colSelBox = colSelBox;
    this.showFooter = false;
    //没人存在点击事件
    this.onRowSelectEvent = true;
    this.filter = false;
    this.settingGridFlag = false;
    this.curFirstResult = 0;
    this._moreSel = moreSel;
    this.pageSize = _pageSize;
    this.selectedIdsAry = [];
    this.queryFieldAry = [];
    this.fontIconAry = [];
    this.fontIconItemAry = [];
    this.customAry = [];
    this.funNameAry = [];
    this.gridType = "grid";
    //编辑类型表格需要的参数
    this.defValues = [];
};

dhtmlXGridObject.prototype.initPagin = function (hasPagin,paginType='default') {
    if (hasPagin) {
        $(this.entBox).after('<div class="girdPaging" style="position: relative;"  id="girdPaging' + this.gridId + '"></div>');
        this.addGridPagin("girdPaging" + this.gridId);
        if(paginType==='small'){
            $('#girdPaging' + this.gridId).find(".pagin-right-cell .dhx_toolbar_btn").hide();
            $('#girdPaging' + this.gridId).find(".pagin-right-cell .dhx_toolbar_text").hide();
            $('#girdPaging' + this.gridId).find(".pagin-right-cell .pagin-sel-ctl").show();
            $('#girdPaging' + this.gridId).find(".pagin-right-cell .pagin-sel-ctl").show();
        }
    }
};

dhtmlXGridObject.prototype.addGridPagin = function (
    containerId,
    hideFlag
) {
    var gridObj = this;
    this.pagingContainer = containerId;
    var paginObj = new GoingPagin(containerId, hideFlag, gridObj);
    this.hasPagination = true;
    this.paginObj = paginObj;
    this.paginObj.initPaginCtl(0);
};

function _getSelectLabel(myGrid) {
    if (myGrid != null && myGrid.colSelType === "radioBox") {
        return `<span>单选</span>`;
    } else {
        return `<span class="_selectChBox grid_check_box" style="position: relative;left:-4px;"  title="">
                    <i data-v-394040b0="" class="ivu-icon ivu-icon-md-square-outline"></i>
                 </span>`;
    }
}

function _getNumLabel(myGrid) {
    let settingBtnId = GoingUtils.getUUid(10);
    myGrid.settingBtnId = settingBtnId;
    return `<div class="setting-btn" style="cursor: pointer;padding-left: 4px;" id="${settingBtnId}">
            <i class="ivu-icon ivu-icon-md-settings" style="font-size: 18px;"></i>
        </div>`;
}

function onKeyPressed(code, ctrl, shift, myGrid) {
    if(code==91&& ctrl){

        myGrid.setCSVDelimiter("\t");
        myGrid.copyBlockToClipboard();
    }
    if (code == 67 && ctrl) {
        if (!myGrid._selectionArea)
            return alert("You need to select a block area in grid first");
        myGrid.setCSVDelimiter("\t");
        myGrid.copyBlockToClipboard();
    }
    if (code == 86 && ctrl) {
        myGrid.setCSVDelimiter("\t");
        myGrid.pasteBlockFromClipboard();
    }
    return true;
}

let getFilterAry = function (
    filter,
    filterAry,
    filterType,
    myGrid,
    fieldId,
    label
) {
    if (filter === true) {
        myGrid.filter = true;
        filterAry.push("#" + filterType + "_filter");
        //将需要进行过滤的字段储存起来
        myGrid.filterFieldAry.push(fieldId);
    } else if (filter === "moreHeader") {
        myGrid.filter = true;
        filterAry.push(label.split("$")[1]);
    } else {
        filterAry.push("&nbsp;");
    }
};

//初始化表格控件
function __initComboDrop(
    type,
    cusItem,
    index,
    myGrid,
    comboAry
) {
    if (type === "co" || type === "coro") {
        cusItem.fieldNum = index;
        if (myGrid.colSelBox) {
            ++cusItem.fieldNum;
        }
        if (myGrid.colOrderNum) {
            ++cusItem.fieldNum;
        }
        comboAry.push(cusItem);
    }
}

function __initColOrderNum(
    myGrid,
    filterAry,
    labelAry,
    labelWid,
    colAlign,
    colTypeAry,
    colSortAry,
    switchAry
) {
    //如果需要排序号

    if (this.colOrderNum) {
        myGrid.defValues.unshift("");
        myGrid.fontIconAry.unshift(``);
        myGrid.fontIconItemAry.unshift("");
        filterAry.unshift(
            `&nbsp;<i id="${
                myGrid.gridId
                }_search" style="color:#289DD7;font-size:15px;cursor:pointer;" class="fas fa-search clear-icon"></i>`
        );
        myGrid.customAry.unshift("");
        myGrid.funNameAry.unshift("");
        labelAry.unshift(_getNumLabel(myGrid));
        labelWid.unshift("40");
        colAlign.unshift("center");
        colTypeAry.unshift("cntr");
        colSortAry.unshift("na");
        switchAry.unshift("");
    }
}

function __initColSelBox(
    myGrid,
    filterAry,
    labelAry,
    labelWid,
    colAlign,
    colTypeAry,
    colSortAry,
    switchAry
) {

    if (this.colSelBox) {
        myGrid.defValues.unshift(false);
        myGrid.fontIconItemAry.unshift("");
        myGrid.fontIconAry.unshift("");
        filterAry.unshift("");
        myGrid.customAry.unshift("");
        myGrid.funNameAry.unshift("");
        labelAry.unshift(_getSelectLabel(myGrid));
        labelWid.unshift("50");
        colAlign.unshift("center");
        //如果选择状态为radio
        if (myGrid.colSelType === "radioBox") {
            colTypeAry.unshift("ra");
        } else {
            colTypeAry.unshift("ch");
        }
        colSortAry.unshift("na");
        switchAry.unshift("");
    }
}

/**
 * 过滤数据 将数据里面colShow为false的数据过滤掉，免于影响表格的显示
 * @param oldFieldAry
 */
dhtmlXGridObject.prototype.getRealFieldAry=function(oldFieldAry){
    return oldFieldAry.filter((item)=>item.colShow!==false);
}
/**
 * 根据配置信息初始化表格
 * @param config
 */
dhtmlXGridObject.prototype.initGridCtl = function (config) {
    let {fieldAry, hasPagin = false,headerSel=false,headerSelFun,sorting=true} = config;
    fieldAry=this.getRealFieldAry(fieldAry);
    let myGrid = this;
    myGrid.sorting=sorting;
    this.colSelType = config.colSelType || "checkBox";
    this.hasPagin = hasPagin;
    this.autoGrid = false;
    this.paginType = config["paginType"];
    let labelAry = [];
    let filterAry = [];
    let labelWid = [];
    let colAlign = [];
    let colTypeAry = [];
    let comboAry = [];
    let switchAry = []; let switchEdAry = [];
    let colHiddenAry = [];
    if (config["autoWidth"] || !AssertUtils.isNotNull(config["autoWidth"])) {
        myGrid.autoGrid = true;
    }
    if (config["colSelBoxStateFun"]) {
        myGrid.colSelBoxStateFun = config["colSelBoxStateFun"];
    }
    myGrid.initSysProp();
    //列宽是否进行过变化 如果进行过列宽校验 则为true
    myGrid.hasChangeColWidth = false;
    myGrid.filterFieldAry = [];
    myGrid.rowColors = config["rowColors"];
    myGrid.fieldAry = fieldAry;
    myGrid.initGridProp(config);
    if(config.moveCol){
        myGrid.enableColumnMove(true);
    }
    //如果是autoWidth 则计算列宽
    myGrid.__changeFileAryWidth(fieldAry, myGrid);
    let colSortAry = [];
    if (
        AssertUtils.isNotNull(config["afterLoadData"]) &&
        AssertUtils.isFunction(config["afterLoadData"])
    ) {
        this.afterLoadData = config["afterLoadData"];
    }
    //循环字段 组装数据
    fieldAry.forEach(function (cusItem, index) {
        let {
            label,
            align = "left",
            cellFun = "",
            dataType = "str",
            codingMapping = true,
            url = "",
            type = "ro",
            sort = "str",
            id,
            icon,
            colShow = true,
            hidden = false,
            loadCellFun = null,
            filter = false,
            filterType = "text",
            items = null
        } = cusItem;

        //初始化单元格的缺省值
        myGrid.initDefaultValues(cusItem);
        //如果是字体图标字段
        if (type === "fontIcon") {
            myGrid.fontIconItemAry.push(cusItem);
        } else {
            myGrid.fontIconItemAry.push(label);
        }
        //如果传了 cell点击函数 但又没有定义loadCellFun 则系统自动追加
        if (
            AssertUtils.isNotEmpty(cellFun) &&
            !AssertUtils.isNotNull(loadCellFun)
        ) {
            loadCellFun = function (val) {
                return (
                    '<div style="color: #4A90E2;cursor: pointer"  class="customerCell">' +
                    val +
                    "</div>"
                );
            };
        }
        //如果传人了loadCellFun 则表示用户需要干预单元格的值
        if (
            AssertUtils.isNotNull(loadCellFun) &&
            AssertUtils.isFunction(loadCellFun)
        ) {
            type = "custom";
        }
        if (!colShow) {
            return void 0;
        }

        //如果label中存在组合头
        if (label != null && label.indexOf("$") > 0) {
            filter = "moreHeader";
            labelAry.push(label.split("$")[0]);
        } else {
            labelAry.push(label);
        }
        //初始化表格过滤功能
        getFilterAry(filter, filterAry, filterType, myGrid, id, label);
        labelWid.push(myGrid._getColWidth(cusItem));
        colAlign.push(align);
        colTypeAry.push(type);
        //判断如果存在下拉drop
        __initComboDrop(type, cusItem, index, myGrid, comboAry);

        //判断如果是switch
        if (type === "switch") {
            cusItem.fieldNum = index;
            switchAry.push(cusItem);
        } else {
            switchAry.push("");
        }

        if (type === "switch_ed") {
            cusItem.fieldNum = index;
            switchEdAry.push(cusItem);
        }
        //如果是数字类型 则排序方式设置为数字
        if ("int" === dataType || "float" === dataType || "double" === dataType) {
            colSortAry.push("int");
        } else {
            colSortAry.push(sort);
        }

        if (hidden) {
            colHiddenAry.push(id);
        }
        //如果fieldObj["options"]不为空 则表示可能是静态下拉
        if (items != null && AssertUtils.isArray(items)) {
            dropCodingFactory.addStaticOptions(id, items);
        }

        myGrid.fontIconAry.push(icon);
        myGrid.urlMaping[index] = url;
        myGrid.codingMappingObj[index] = codingMapping;
        myGrid.customAry.push(loadCellFun);
        myGrid.funNameAry.push(cellFun);
        if (AssertUtils.isNotEmpty(id)) {
            myGrid.queryFieldAry.push(id);
        }
        //初始化单元格的函数
        myGrid.initCellFun(cusItem, index);
    });
    //如果需要选择列
    __initColSelBox.call(
        this,
        myGrid,
        filterAry,
        labelAry,
        labelWid,
        colAlign,
        colTypeAry,
        colSortAry,
        switchAry
    );
    //  如果需要排序号  则需要进行相应初始化
    __initColOrderNum.call(
        this,
        myGrid,
        filterAry,
        labelAry,
        labelWid,
        colAlign,
        colTypeAry,
        colSortAry,
        switchAry
    );
    //如果存在过滤
    if (myGrid.filter) {
        let list = colAlign.map(item => {
            return `text-align:${item}`;
        });
        myGrid.attachHeader(filterAry.join(","), list);
    }
    myGrid.switchAry = switchAry;
    myGrid.switchEdAry=switchEdAry;
    let arr = colAlign.map(item => {
        return `text-align:${item}`;
    });
    //表格头中文
    myGrid.setHeader(labelAry.join(","), null, arr, labelAry.length);
    this._colSize = labelAry.length;
    //表格宽度
    myGrid.setInitWidths(labelWid.join(","));
    //设置label的摆放位置
    myGrid.setColAlign(colAlign.join(","));
    //设置字段类型
    myGrid.setColTypes(colTypeAry.join(","));
    //设置排序类型
    myGrid.setColSorting(colSortAry.join(","));
    if (hasPagin) {
        //设置分页
        myGrid.initPagin(hasPagin,config.paginType);
    }
    //设置复制
    myGrid.attachEvent("onKeyPress", function (
        code,
        ctrl,
        shift
    ) {
        onKeyPressed(code, ctrl, shift, myGrid);
    });

    //设置表格固定列
    if (
        AssertUtils.isNotNull(config["split"]) &&
        AssertUtils.isNumber(config["split"])
    ) {
        myGrid.splitAt(config["split"]);
    } else if (AssertUtils.isNotNull(config["split"])) {
        myGrid.splitAt(myGrid.getColIndexByField(config["split"]));
    }

    myGrid.groupByFlag = config["groupBy"];
    //如果是多选 而且不存在选择checkbox 则进行多选
    if (this._moreSel && !this.colSelBox) {
        //设置表格为多选
        myGrid.enableMultiselect(true);
    }
    myGrid.init();
    //初始化过滤控件
    myGrid.initFilterCtl(config["filterFun"]);
    myGrid.initGridSettings();
    if(headerSelFun){
      myGrid.headerSelFun=headerSelFun;
    }
    //如果设置为false 则不执行默认事件
    if(config["sysDefEvent"]!==false){
        myGrid.initGridDefEvent(headerSel);
    }


    //设置选计
    if (myGrid.showFooter) {
        myGrid.addSysFooter();
    }

    //设置列 显示隐藏
    colHiddenAry.forEach(function (item) {
        myGrid.setColumnHidden(myGrid.getColIndexByField(item), true);
    });
    //设置编辑状态下的下拉菜单
    this.addGridComboDrop(comboAry);
    //初始化多行表头的样式
    if (myGrid.filter) {
        this.initMoreRowHeaderStyle();
    }
};
dhtmlXGridObject.prototype._getColNewWidths = function (oldSummary) {
    let newSummary = 0;
    let oldWidths = [];
    for (let num = 0; num < this.getColumnsNum(); num++) {
        let oldWidth = this.getColWidth(num);
        newSummary += oldWidth;
        oldWidths.push(oldWidth);
    }

    let newColWidths = [];
    //如果新的宽度大于了以前的宽度
    if ((newSummary - oldSummary) > 10 || (newSummary - oldSummary) < -10) {
        oldWidths.forEach(function (item) {
            if (item != 0) {
                newColWidths.push(item * (oldSummary / newSummary));
            } else {
                return newColWidths.push(0);
            }

        });
    }
    return newColWidths;
};
//设置列隐藏 而且要判断是否要自适应表格的原始宽度。
dhtmlXGridObject.prototype.setColHidden = function (colName, flag = true, autoWidthFlag = true) {
    let gridOldWidth = $("#" + this.gridId).width();
    let colInd = this.getColIndexByField(colName);
    let newWidths = [];
    this.setColumnHidden(colInd, flag);
    if (colInd >= 0) {
        if (autoWidthFlag) {
            //表示true 则隐藏 隐藏的时候将自己的宽度分给其他列
            if (flag) {
                newWidths = this._getColNewWidths(gridOldWidth);
            } else {
                newWidths = this._getColNewWidths(gridOldWidth);
            }
            newWidths.forEach((item, index) => {
                this.setColWidth(index, item);
            });
        }
    }
};
//初始化多行表头的样式信息
dhtmlXGridObject.prototype.initMoreRowHeaderStyle = function () {
    $(`#${this.gridId} .hdr`)
        .find("td")
        .each(function (index, item) {
            if ($(item).attr("colspan") > 0) {
                $(item).css("borderBottom", "1px solid #A6B4D2");
            } else {
                $(item).css("vertical-align", "middle");
            }
        });
};

//初始化单元格函数
dhtmlXGridObject.prototype.initCellFun = function (
    {type, initCellFun},
    num
) {
    if (this.colOrderNum) {
        ++num;
    }
    if (this.colSelBox) {
        ++num;
    }
    if (type === "combo") {
        this.setComboLoadFun(num, function (comboObj) {
            initCellFun(comboObj);
        });
    }

    if (type === "win") {
        this.setDialogFun(num, function (editor, obj) {
            initCellFun(editor, obj);
        });
    }
};
/**
 * 设置表格diloag的加载函数
 */
dhtmlXGridObject.prototype.setDialogFun = function (colIndex, fun) {
    if (this.showDialogFun != null) {
        this.showDialogFun[colIndex] = fun;
    } else {
        this.showDialogFun = {};
        this.showDialogFun[colIndex] = fun;
    }
};
/**
 * 设置表格combo下拉 加载数据的函数
 */
dhtmlXGridObject.prototype.setComboLoadFun = function (colIndex, fun) {
    if (this.comboLoadFun != null) {
        this.comboLoadFun[colIndex] = fun;
    } else {
        this.comboLoadFun = {};
        this.comboLoadFun[colIndex] = fun;
    }
};
//添加grid的下拉菜单
dhtmlXGridObject.prototype.addGridComboDrop = function (comboAry) {
    let gridObj = this;
    $.each(comboAry, function (key, val) {
        let record = new Record(val);
        let options = record.getValue("options");
        //如果存在定义的options 则表示静态下拉
        if (options != null && !$.isEmptyObject(options)) {
            let optionsObj = {};
            if (AssertUtils.isArray(options)) {
                $.each(options, function (sonKey, sonVal) {
                    if (AssertUtils.isNotEmpty(sonVal["value"])) {
                        (optionsObj)[sonVal.value] = sonVal.text;
                    }
                });
            } else {
                optionsObj = options;
            }
            gridObj.getComboByJson(record.getValue("fieldNum"), optionsObj);
        } else if (AssertUtils.isNotEmpty(record.getValue("url"))) {
            //如果设置的是url则表示查询来构建下拉
        }
    });
};
/**
 * 根据json对象来构建 commbo下拉
 * @param columNum
 * @param jsonObj
 */
dhtmlXGridObject.prototype.getComboByJson = function (
    columNum,
    jsonObj
) {
    for (let name in jsonObj) {
        this.getCombo(columNum).put(name, jsonObj[name]);
    }
};
//设置选计
dhtmlXGridObject.prototype.initFilterCtl = function (filterFun) {
    let myGrid = this;

    $(`#${this.gridId}_search`).click(function () {
        let gridId = ($(this).attr("id")).split("_")[0];
        let backJson = {};

        var colIndex = 0;
        $(`#${gridId} .filter`)
            .css("position", "relative")
            .each(function () {
                let inputVal = $(this)
                    .find("input")
                    .val();
                if (AssertUtils.isNotEmpty(inputVal)) {
                    (backJson)[myGrid.filterFieldAry[colIndex]] = inputVal;
                }
                ++colIndex;
            });
        if (AssertUtils.isFunction(filterFun)) {
            filterFun(backJson, myGrid);
        }
    });
    $(`#${this.gridId} .filter`)
        .css("position", "relative")
        .each(function () {

        });
};
//设置选计
dhtmlXGridObject.prototype.addSysFooter = function () {
    this.addFooterBar("hideCount", "隐藏");
};
//设置初始化表格设置相关功能
dhtmlXGridObject.prototype.initGridSettings = function (fieldName) {
    var elIndex = ArrayUtils.aryIndexOf(this.queryFieldAry, fieldName);
    return elIndex;
};
//初始化表格事件
dhtmlXGridObject.prototype.initGridDefEvent = function (headerSel) {
    let mygrid = this;
    this.initSelectCellEvent();
    if (this.colOrderNum) {
        $("#" + this.settingBtnId).click(function () {
            let pos = GoingUtils.getElementPosition($(this).get(0));
            //如果第一次点击 则创建对象 并显示 如果不是 则显示
            if (!mygrid.settingGridFlag) {
                mygrid.settingGrid = new GridSettingPanel(mygrid.fieldAry, mygrid);
                mygrid.settingGridFlag = true;
                mygrid.settingGrid.show(pos);
            } else {
                mygrid.settingGrid.show(pos);
            }
        });
    }
    //初始化点击事件
    if (this.onRowSelectEvent) {
        this.attachEvent("onRowSelect", function (
            rowId
        ) {
            $(".go-setting-grid").hide();
            gridCommonEvent.onRowSelect(rowId, mygrid);
        });
    }
    //如果存在选择列
    if (this.colSelBox) {
        this.attachEvent("onCheckbox", function (
            rowId,
            cellInd,
            state
        ) {
            gridCommonEvent.doOnCheck(mygrid, rowId, cellInd, state);
        });
    }


    this.attachEvent("onHeaderClick", function (ind) {

        let leftGrid = this;
        var selColInd = leftGrid.getSelectColInd();
        if (selColInd !== ind) {
            mygrid.clearSelection();
            mygrid.selectedIdsAry=[];
        }
        return true;
    });
};

dhtmlXGridObject.prototype.getAllData = function () {
    //再获取相应的值
    var ids = this.getAllRowIds().split(",");
    var jsonRecords = [];
    var gridObj = this;
    for (var num = 0; num < ids.length; num++) {
        var rowRecord = {};
        rowRecord["id"] = ids[num];
        gridObj.queryFieldAry.forEach(function (fieldName) {
            rowRecord[fieldName] = gridObj.getCellValue(ids[num], fieldName);
        });
        jsonRecords.push(rowRecord);
    }

    if ($ != null && $.toJSON != null) {

        return $.toJSON(jsonRecords);
    } else {
        return jsonRecords;
    }
};
dhtmlXGridObject.prototype.getColIndexByField = function (fieldName) {
    var elIndex = ArrayUtils.aryIndexOf(this.queryFieldAry, fieldName);
    if (this.colOrderNum) {
        ++elIndex;
    }
    if (this.colSelBox) {
        ++elIndex;
    }
    return elIndex;
};
//判断某一行是否已经选中
dhtmlXGridObject.prototype.checkRowIsSelected = function (rowId) {
    var state = false;
    var colIndex = this.getColIndexByField("select");
    if (colIndex >= 0) {
        var cellObj = this.cells(rowId, colIndex);
        state = cellObj.getValue();
        if (state == 0) {
            state = true;
        } else {
            state = false;
        }
    }
    return !state;
};
//设置某行选中
dhtmlXGridObject.prototype.setRowIsSelected = function (
    rowId,
    executeFlag = true
) {
    var colIndex = this.getColIndexByField("select");
    if (colIndex >= 0) {
        var cellObj = this.cells(rowId, colIndex);
        var state = cellObj.getValue();
        if (state == 0) {
            state = true;
        } else {
            state = false;
        }
        cellObj.setValue(state);
        if (executeFlag) {
            gridCommonEvent.doOnCheck(this, rowId, colIndex, state);
        }
    }
};
//获取选择行的所有的id集合
dhtmlXGridObject.prototype.getSelectedRowIds = function (type) {
    if (type == "array") {
        return this.selectedIdsAry;
    } else {
        var idsStrs = this.selectedIdsAry.join(GoingUtils.relChart);
        if (AssertUtils.isNotEmpty(idsStrs)) {
            return idsStrs;
        } else {
            var colIndex = this.getColIndexByField("select");
            //如果存在选 则不能获取当前选择行
            if(colIndex>=0){
                this.clearSelection();
                return "";
            }else{
                if (AssertUtils.isNotEmpty(this.getSelectedRowId())) {
                    var uuidAry = this.getSelectedRowId().split(GoingUtils.relChart);
                    return uuidAry.join(GoingUtils.relChart);
                } else {
                    return "";
                }
            }

        }
    }
}
;
//设置某行未选中
dhtmlXGridObject.prototype.setRowIsNotSelected = function (rowId) {
    let colIndex = this.getColIndexByField("select");
    if (colIndex >= 0) {
        //要判断记录是否存在
        let rowIndex=this.getRowIndex(rowId);
        if(rowIndex>=0){
            let cellObj = this.cells(rowId, colIndex);
            let state = cellObj.getValue();
            if (state === 0) {
                state = true;
            } else {
                state = false;
            }
            cellObj.setValue(state);
            gridCommonEvent.doOnCheck(this, rowId, colIndex, state);
        }
    }
};
//获取选择在表格中的位置
dhtmlXGridObject.prototype.getSelectColInd = function () {
    let myGrid = this;
    //判断是否需要排序 序号列
    if (myGrid.colOrderNum) {
        return 1;
    }
    //如果存在序号 则返回1  如果不存在序号则返回0
    if (myGrid.colSelBox) {
        return 0;
    }
};
/**
 * 根据指定列 的相应值 对行进行颜色变化
 * @param columnName
 * @param colValue
 * @param color
 * @param flag
 */
dhtmlXGridObject.prototype.setRowsColor = function (
    columnName,
    colValue,
    color,
    flag
) {
    var _color = "#FFCCFF";
    if (!AssertUtils.isNotEmpty(flag)) {
        flag = false;
    }
    if (AssertUtils.isNotEmpty(color)) {
        _color = color;
    }
    var mainGrid = this;
    mainGrid.forEachRow(function (id) {
        var cellVal = mainGrid.getCellValue(id, columnName);
        if (AssertUtils.isArray(colValue)) {
            if (ArrayUtils.aryContains(colValue, cellVal)) {
                mainGrid.setRowColor(id, _color);
            }
        } else {
            if (flag) {
                if (cellVal === colValue) {
                    mainGrid.setRowColor(id, _color);
                }
            } else {
                if (cellVal.indexOf(colValue) >= 0) {
                    mainGrid.setRowColor(id, _color);
                }
            }
        }
    });
};
dhtmlXGridObject.prototype.setCellTextColor = function (
    columnName,
    source
) {
    let mainGrid = this;
    mainGrid.forEachRow((rowId) => {
        var cellVal = mainGrid.getCellValue(rowId, columnName);
        mainGrid.forEachCell(rowId, (cellObj, index) => {
            if (cellVal === cellObj.cell.innerText) {
                mainGrid.setCellTextStyle(rowId, index, "color:" + source[cellVal]);
            }
        });
    });
};
//将以前打勾的数据设置成未打勾
dhtmlXGridObject.prototype.setCheckedRowsToNotChecked = function () {
    var mygrid = this;
    mygrid.forEachRowA(function (rowId) {
        let cellObj = mygrid.cells(rowId, mygrid.getSelectColInd());
        let state = getBooleanByInt(cellObj.getValue());
        if (!state) {
            cellObj.setValue(state);
        }
    });
};
dhtmlXGridObject.prototype.clearSelCountVal = function () {
};
//常用表格事件
var gridCommonEvent = {
    onRowSelect: function (rowId, mygrid) {
        if (!mygrid.selectRelCheck) {
            return false;
        }
        //如果是多选
        if (mygrid._moreSel) {
            if (mygrid.checkRowIsSelected(rowId)) {
                mygrid.setRowIsNotSelected(rowId);
            } else {
                mygrid.setRowIsSelected(rowId);
            }
        } else {
            //如果是单选 先把打钩的数据取消掉
            if (mygrid.colSelBox) {
                mygrid.setCheckedRowsToNotChecked();
            }
            mygrid.selectedIdsAry = [];
            mygrid.clearSelCountVal();
            mygrid.setRowIsSelected(rowId);
        }
    },
    doOnCheck: function (
        leftGrid,
        rowId,
        cellInd,
        state
    ) {
        var selColInd = leftGrid.getSelectColInd();
        if (cellInd === selColInd) {
            if (state) {
                if (!ArrayUtils.aryContains(leftGrid.selectedIdsAry, rowId)) {
                    leftGrid.selectedIdsAry.push(rowId);
                }
            } else {
                leftGrid.selectedIdsAry = ArrayUtils.aryRemoveEl(
                    leftGrid.selectedIdsAry,
                    rowId
                );
                leftGrid.clearSelection();
            }
        }
        leftGrid.initCheckSelCount(rowId, state);
    }
};
dhtmlXGridObject.prototype.initCheckSelCount = function () {

};

//判断列头是否已经选中
dhtmlXGridObject.prototype.judgeHeaderChIsSel = function (elObj) {
    let curChSrc = $(elObj).html();
    //表示已经选中了
    if (curChSrc.indexOf("ivu-icon-md-checkbox") > 0) {
        return true;
    }
    //表示未选择中
    if (curChSrc.indexOf("ivu-icon-md-square-outline") > 0) {
        return false;
    }
};
//设置当前选择列 列头为选中
dhtmlXGridObject.prototype.setHeaderChIsSel = function () {
    $("#" + this.gridId + " ._selectChBox").each(function () {
        $(this).find("i").attr("class", `ivu-icon ivu-icon-md-checkbox`);
    });
};
//设置当前选择列 列头为未选中
dhtmlXGridObject.prototype.setHeaderChIsNotSel = function () {
    $("#" + this.gridId + " ._selectChBox").each(function () {
        $(this).find("i").attr("class", `ivu-icon ivu-icon-md-square-outline`);
    });
};

function executeCheck(mygrid, flag) {
    mygrid.setCheckedRows(mygrid.getSelectColInd(), flag);
    //执行用户自定义的onCheckboxEvent事件
    if (
        mygrid.onCheckboxEvent != null &&
        AssertUtils.isFunction(mygrid.onCheckboxEvent)
    ) {
        mygrid.idsAry.forEach(function (rowId) {
            mygrid.onCheckboxEvent(rowId, mygrid.getSelectColInd(), flag);
        });
    }
}

//初始化表格事件
dhtmlXGridObject.prototype.initSelectCellEvent = function () {
    let mygrid = this;
    $("#" + this.gridId + " ._selectChBox").click(function () {
        if (!mygrid.judgeHeaderChIsSel(this)) {
            if (mygrid.colSelBox) {
                //对所有记录进行选择操作
                mygrid.setHeaderChIsSel();
                executeCheck(mygrid, true);
                mygrid.selAllRecord&&mygrid.selAllRecord(true);
            }
            mygrid.selectedIdsAry = mygrid.idsAry;
        } else {
            //设置取消所有记录的选择
            if (mygrid.colSelBox) {
                mygrid.setHeaderChIsNotSel();
                executeCheck(mygrid, false);
            }
            mygrid.selectedIdsAry = [];
            mygrid.selAllRecord&&mygrid.selAllRecord(false);
        }
    });
};

//初始化查询字段 如果查询的字段不包含id字段 则需要将id字段追加进来。
dhtmlXGridObject.prototype.initQueryFieldAry = function () {
    let girdTable = this;
    if (!ArrayUtils.aryContains(girdTable.queryFieldAry, "id")) {
        girdTable.queryFieldAry.push("id");
    }
    let queryAry = [];
    girdTable.queryFieldAry.forEach(function (item) {
        if (item !== "select" && item !== "num") {
            queryAry.push(item);
        }
    });
    return queryAry;
};

//获取表格所有数据
dhtmlXGridObject.prototype.getGridAllData = function () {
    var ids = this.getAllRowIds(GoingUtils.relChart).split(GoingUtils.relChart);
    var gridObj = this;
    let backList = [];
    ids.forEach(function (item) {
        let rowValues = gridObj.getRowRecord(item);
        backList.push(rowValues);
    });
    return backList;
};

//刷新表格根据url
dhtmlXGridObject.prototype.flushGridByUrl = function ({
                                                          url,
                                                          method,
                                                          backFun,
                                                          params = {},
                                                          initDataFun,
                                                          selRecordFlag = false
                                                      }) {
    let girdTable = this;
    let backType = GoingUtils.defaultBackType;
    let curRecordId = this.getSelectedRowId();
    //如果没有传入url 则沿用缓存的查询url
    if (!AssertUtils.isNotEmpty(url)) {
        url = this.queryUrl;
    }
    if(!AssertUtils.isNotEmpty(url)){
        return void(0);
    }
    let queryCommand = new QueryCommand({url: url, method: method || this.method});
    //缓存url 和查询参数
    this.queryUrl = url;
    this.params = params;
    queryCommand.executeQuery({
        params: girdTable.getQueryDs(params), successFun: (backData) => {
            let initDataFlag = false;
            if (!girdTable.parseByData) {
                return void (0);
            }

            if (initDataFun) {
                backData = initDataFun(backData);
                girdTable.initDataFun = initDataFun;
                initDataFlag = true;
            }

            if (girdTable.initDataFun && !initDataFlag) {
                backData = girdTable.initDataFun(backData);
            }


            if (backData["data"] != null) {
                backData = backData["data"];
            }


            if (backData && backData["records"] != null) {
                if (backData["records"] && backData["records"].length === 0 && girdTable.curPage !== 1) {
                    if (girdTable.curPage - 2 >= 0) {
                        girdTable.paginObj.setPage(girdTable.curPage - 2);
                        return;
                    }
                }
                girdTable.parseByData && girdTable.parseByData(backData["records"], {total: backData["total"]});
                if (AssertUtils.isFunction(backFun)) {
                    backFun({list: backData["records"], ids: girdTable.idsAry, gridObj: girdTable});
                }
            } else if (backData && backData["list"] != null) {
                girdTable.parseByData && girdTable.parseByData(backData["list"], backData["pagination"]);
                if (AssertUtils.isFunction(backFun)) {
                    backFun({list: backData["list"], ids: girdTable.idsAry, gridObj: girdTable});
                }
            } else {
                girdTable.parseByData && girdTable.parseByData(backData, backType);
                if (AssertUtils.isFunction(backFun)) {
                    backFun({list: backData, ids: girdTable.idsAry, gridObj: girdTable});
                }
            }
            if (girdTable.copy) {
                girdTable.enableBlockSelection();
            }


            //如果存在全局回调 则调用
            if (girdTable._backFun != null && AssertUtils.isFunction(girdTable._backFun)) {
                if (backData && backData["records"] != null) {
                    girdTable._backFun({list: backData["records"], ids: girdTable.idsAry, gridObj: girdTable});
                } else if (backData && backData["list"] != null) {
                    girdTable._backFun({list: backData["list"], ids: girdTable.idsAry, gridObj: girdTable});
                }

            }

            //表示选中当前行
            if (selRecordFlag) {
                girdTable.selectRow(curRecordId, true);
            }
            curRecordId = null;
            girdTable.initFooterInfo({});
        }
    }
    );
};

/**
 * 初始化查询ds
 * @returns {Dataset}
 */
dhtmlXGridObject.prototype.getQueryDs = function (params) {
    return $.extend({current:this.curPage,size:this.curPageSize},params);
    // return $.extend({current:this.curPage,currentPage:this.curPage,size:this.curPageSize,pageSize:this.curPageSize},params);
};
dhtmlXGridObject.prototype.setQueryUrl = function (url) {
    this.queryUrl = url;
};
/**
 * 重新加载数据
 * @param pd
 */
dhtmlXGridObject.prototype.reloadData = function (pd) {
    //如果传人的是布尔值 则表示是否选中当前记录 如果是对象 则表示是参数
    let selRecordFlag = false;
    if (AssertUtils.isBoolean(pd)) {
        selRecordFlag = AssertUtils.parseBoolean(pd);
    }
    if (this.gridType === "treeGrid") {
        this.flushTreeGridByUrl(this.queryUrl);
    } else {
        if (pd != null) {
            this.flushGridByUrl({url: this.queryUrl, params: pd, selRecordFlag});
        } else {
            //判断是否存在系统缓存的参数 存在则传递系统的默认参数
            if (this.params != null) {
                this.flushGridByUrl({
                    url: this.queryUrl,
                    params: this.params,
                    selRecordFlag
                });
            } else {
                //  如果不存在 则根据url查询
                this.flushGridByUrl({url: this.queryUrl, selRecordFlag});
            }
        }
    }
};

//清空表格的相应状态
dhtmlXGridObject.prototype.initGridState = function () {
    this.selectedIdsAry = [];
    this.idsAry = [];
    this.clearAll();
};

//获取当前行对应的值
dhtmlXGridObject.prototype.getGridRowValues = function (
    _dataset,
    rowNum
) {
    let myGrid = this;
    let rowValue = [];
    let rowValues = _dataset.getPropValues()[rowNum];
    //获取记录值
    myGrid.queryFieldAry.forEach(function (item) {
        let colIndex = _dataset.getColumnIndex(item);
        rowValue.push(rowValues[colIndex]);
    });
    //判断是否需要选择box
    if (myGrid.colSelBox) {
        //判断是否存在 colselBox干预函数 如果存在则需要
        if (
            AssertUtils.isNotNull(myGrid.colSelBoxStateFun) &&
            AssertUtils.isFunction(myGrid.colSelBoxStateFun)
        ) {
            rowValue.unshift(myGrid.colSelBoxStateFun(_dataset, rowValue));
        } else {
            rowValue.unshift(false);
        }
    }
    //判断是否需要排序 序号列
    if (myGrid.colOrderNum) {
        rowValue.unshift(0);
    }
    return rowValue;
};

/**
 * 根据用户的数据 添加表格数据
 * @param ary
 */
dhtmlXGridObject.prototype.flushGridByJsonArray = function (ary) {
    //恢复表格状态
    this.initGridState();
    for (let rowNum = 0; rowNum < ary.length; rowNum++) {
        //获取行id
        let c = ary[rowNum].id || GoingUtils.getUUid(12);
        //获取行数据
        let gridDateNew = this.getRowsD(ary[rowNum]);
        this.idsAry.push(c);
        this.rowsBuffer.push({
            idd: c,
            data: {id: c, data: gridDateNew},
            _parser: this._process_json_row,
            _locator: this._get_json_data
        });
        this.rowsAr[c] = {id: c, data: gridDateNew};
    }
    this.render_dataset();
    this._parsing = !1;
    //加载后的回掉函数
    if (AssertUtils.isFunction(this.afterLoadData)) {
        this.afterLoadData();
    }
};

//根据dataset来组装表格
dhtmlXGridObject.prototype.parseByData = function (list,paginInfo) {

    //刷新数据的同时 需要将header的checkbox的钩钩去掉
    this.setHeaderChIsNotSel();
    let myGrid = this;
    this.parseByJson(list,paginInfo);
    //初始化统计信息
    this.initFooterInfo(list);
    //激活加载数据事件
    this.callEvent("onRowAdded", list, "rows");
    //设置表格行颜色信息
    this.setRowsColorAfterLoadData();
    //设置表格数据分组
    if (
        AssertUtils.isNotNull(this.groupByFlag) &&
        AssertUtils.isNumber(this.groupByFlag)
    ) {
        myGrid.groupBy(this.groupByFlag);
        //重新初始化下序号
        setTimeout(function () {
            myGrid.initColOrderNum();
        }, 100);
    } else if (AssertUtils.isNotNull(this.groupByFlag)) {
        myGrid.groupBy(myGrid.getColIndexByField(this.groupByFlag));
        //重新初始化下序号
        setTimeout(function () {
            myGrid.initColOrderNum();
        }, 100);
    }
};
//设置行颜色
dhtmlXGridObject.prototype.setRowsColorAfterLoadData = function () {
    var myGrid = this;
    //如果存在颜色定义 则需要执行该操作
    if (AssertUtils.isNotNull(myGrid.rowColors)) {
        myGrid.forEachRow(function (id) {
            var rowColor = myGrid.rowColors(myGrid.getRowRecord(id), myGrid.rowsAr[id]);
            //如果返回的颜色存在 才需要操作
            if (AssertUtils.isNotNull(rowColor) && AssertUtils.isNotEmpty(rowColor)) {
                myGrid.setRowColor(id, rowColor);
            }
        });
    }
};
//重新初始化序号
dhtmlXGridObject.prototype.getPreGroupSize = function (trObj, obj) {
    if (trObj != null && trObj.get(0) != null) {
        let preEl = trObj.prev();
        if (preEl.get(0) != null) {
            if (preEl.find(".group_row").get(0) != null) {
                ++obj["groupSize"];
            }
            this.getPreGroupSize(preEl, obj);
        }
    }
};
//重新设置排序号
dhtmlXGridObject.prototype.initColOrderNumCell = function () {
    let index = 1;
    if (this.colOrderNum) {
        $("#" + this.gridId)
            .find(".grid-index-cell")
            .each(function () {
                $(this).text(index++);
            });
    }
};
//重新初始化序号
dhtmlXGridObject.prototype.initColOrderNum = function () {
    let myGrid = this;
    if (this.colOrderNum) {
        $(".grid-index-cell").each(function () {
            let oldVal = $(this).text();
            let obj = {groupSize: 0};
            myGrid.getPreGroupSize(
                $(this)
                    .parent()
                    .parent(),
                obj
            );
            $(this).text(parseFloat(oldVal) - obj["groupSize"]);
        });
    }
};

//初始化表格的相关统计信息
dhtmlXGridObject.prototype.initFooterInfo = function () {
    //如果用户定义需要显示 底部栏 则显示如果定义为不显示 则进行隐藏
    if (this.showFooter) {
        this.closeFooterBar("selCount");
        this.addFooterBar("selCount", "选计");
        this.addFooterBar("sumCount", "小计");
        this.addFooterBar("totalCount", "总计");
    }
};
//根据dataset来组装表格
dhtmlXGridObject.prototype.parseByJson = function (backData,{total}) {
    this.rowsBufferTemp = {};
    if (this.hasPagination) {
        //初始化分页信息
        if(total>0){
            this.paginObj.initPaginCtl(total);
        }else{
            this.paginObj.initPaginCtl(0);
        }
    }
    //恢复表格状态
    this.initGridState();
    for (let rowNum = 0; rowNum < backData.length; rowNum++) {
        //获取行id
        let c = backData[rowNum].id || GoingUtils.getUUid(12);
        this.rowsBufferTemp[c] = backData[rowNum];
        //获取行数据
        let gridDateNew = this.getRowsD(backData[rowNum]);
        this.idsAry.push(c);
        this.rowsBuffer.push({
            idd: c,
            data: {id: c, data: gridDateNew},
            _parser: this._process_json_row,
            _locator: this._get_json_data
        });
        this.rowsAr[c] = {id: c, data: gridDateNew};
    }
    this.render_dataset();
    this._parsing = !1;
    //加载后的回掉函数
    if (AssertUtils.isFunction(this.afterLoadData)) {
        this.afterLoadData();
    }
    //数据加载完后 从下拉中获取对应的值
    dropCodingFactory.getCodingRelVal(this.idsAry);
    //初始化SwitchEvent事件
    this.initSwitchEvent(this.idsAry);
}
;
dhtmlXGridObject.prototype.initSwitchEvent=function(idsAry){
    if(this.switchEdAry!=null&&this.switchEdAry.length>0){
        if(idsAry==null){
            idsAry=this.getAllRowIds();
        }
        let gridObj=this;
        //循环switch编辑列
        this.switchEdAry.forEach(function (itemObj) {
            let colIndex=gridObj.getColIndexByField(itemObj["id"]);
            gridObj.initSwitchEventAgain((idsAry+"").split(","),colIndex);
        });
    }
};
dhtmlXGridObject.prototype.initSwitchEventAgain=function(idsAry,colIndex){
    var gridObj=this;
    idsAry.forEach((rowId)=>{
        //注册相应点击事件
        $(`#cell_switch_`+rowId+"_"+colIndex).bind('click',function(){
            $(this).unbind();
            let oldVal=gridObj.cells(rowId, colIndex).getValue();
            if(oldVal===true||oldVal==="true"){
                gridObj.cells(rowId, colIndex).setValue(false,true);
                gridObj.callEvent("onSwitchChange", [rowId,colIndex,false]);
            }else{
                gridObj.cells(rowId, colIndex).setValue(true,true);
                gridObj.callEvent("onSwitchChange", [rowId,colIndex,true]);
            }
        });
    });
};
//获取表格所有数据
dhtmlXGridObject.prototype.getTreeItem = function (item) {
    let girdTable = this;
    let sonItems = [];
    if (item.children && item.children.length > 0) {
        item.children.forEach(function (sonItem) {
            sonItems.push(girdTable.getTreeItem(sonItem));
        });
    }
    let itemObj = {
        id: item["id"],
        data: girdTable.getRowsD(item),
        rows: sonItems
    };
    if (sonItems.length > 0) {
        //如果存在排序号
        if (girdTable.colOrderNum) {
            itemObj["data"][1] = {value: itemObj["data"][1], image: "folder.gif"};
        } else {
            itemObj["data"][0] = {value: itemObj["data"][0], image: "folder.gif"};
        }
    }
    return itemObj;
};

/**
 * 查询treegrid数据
 * @param url
 * @param type
 * @returns {*}
 */
dhtmlXGridObject.prototype.flushTreeGridByUrl = function (url) {
    let girdTable = this;
    let queryCommand = new QueryCommand(url);
    this.queryUrl = url;
    this.gridType = "treeGrid";
    let paramDataJson = {dataset: girdTable.getQueryDs({})};
    queryCommand.executeQuery(
        paramDataJson,
        function (response) {
            girdTable.clearAll();

            let jsonObj = {};
            let rowsRecords = [];
            response.forEach(function (item) {
                rowsRecords.push(girdTable.getTreeItem(item));
            });
            (jsonObj)["rows"] = rowsRecords;
            let jsonStr = JSON.stringify(jsonObj);
            girdTable["_process_json"](jsonStr);
            girdTable.expandAll();
        },
        function () {
        },
        "json"
    );

    return dhx4.ajax.get(url, this.xmlLoader);
};

//获取列数据
dhtmlXGridObject.prototype.getRowsD = function (backData) {
    let ret = [];
    let myGrid = this;
    this.queryFieldAry.forEach(function (item) {
        ret.push(backData[item]);
    });
    if (myGrid.colSelBox) {
        ret.unshift(false);
    }
    if (myGrid.colOrderNum) {
        ret.unshift(0);
    }
    return ret;
};

/**
 * 获取数据库返回的record数据
 * @param rowId
 */
dhtmlXGridObject.prototype.getRowRecordDb = function (rowId) {
    let rowObj = this.rowsBufferTemp[rowId];
    return rowObj;
};

function _getScrollWidth() {
    var oP = document.createElement('p'),
        styles = {
            width: '100px',
            height: '100px',
            overflowY: 'scroll'
        }, scrollbarWidth;
    for (let i in styles) {
        oP.style[i] = styles[i];
    }
    document.body.appendChild(oP);
    scrollbarWidth = oP.offsetWidth - oP.clientWidth;
    oP.remove();
    return scrollbarWidth;
}

/**
 * 变更表格的宽度
 */
dhtmlXGridObject.prototype.changeBoxColWidth = function () {
    this.hasChangeColWidth = true;
    let colWidth = this.getColWidth(this._colSize - 1);
    this.setColWidth(this._colSize - 1, colWidth - _getScrollWidth());
};

dhtmlXGridObject.prototype.boxHasScroller = function () {
    var obj = $("#" + this.gridId + " .objbox").get(0);
    if (obj.scrollHeight > obj.clientHeight || obj.offsetHeight > obj.clientHeight) {
        return true;
    }
    return false;
};
/**
 * 获取公共编码的url 如果用户没有定义url 则调用系统编码的url
 * @param celInd
 * @returns {*}
 */
dhtmlXGridObject.prototype.getCodingType = function (celInd) {
    var gridObj = this;
    if (this.colOrderNum) {
        celInd = celInd - 1;
    }
    if (this.colSelBox) {
        celInd = celInd - 1;
    }
    if (AssertUtils.isNotEmpty(gridObj.urlMaping[celInd])) {
        return gridObj.urlMaping[celInd];
    } else {
        return "static_drop_" + this.getFieldNameByColInd(celInd);
    }
};
//获取是否需要编码映射的标志
dhtmlXGridObject.prototype._getCodingMappingFlag = function (celInd) {
    let gridObj = this;
    if (this.colOrderNum) {
        celInd = celInd - 1;
    }
    if (this.colSelBox) {
        celInd = celInd - 1;
    }
    return gridObj.codingMappingObj[celInd];
};

dhtmlXGridObject.prototype.getFieldNameByColInd = function (colInd) {
    return this.queryFieldAry[colInd];
};

//添加底部工具栏
dhtmlXGridObject.prototype.addFooterBar = function (
    flagId,
    label
) {
    let myGrid = this;
    let htmls = [];
    if (myGrid.fieldAry.length > 0) {
        if (this.colOrderNum) {
            htmls.push(`#cspan`);
        }
        if (this.colSelBox) {
            htmls.push(`#cspan`);
        }
        myGrid.fieldAry.forEach(function ({id, label}) {
            htmls.push(`<div id='${id}_${flagId}'>-</div>`);
        });
    }
    if ("hideCount" === flagId) {
        htmls[0] = `<div style="display: none;" id="${
            this.gridId
            }_${flagId}">${label}</div>`;
    } else {
        htmls[0] = `<div style="font-size: 11px;" id="${
            this.gridId
            }_${flagId}">${label}</div>`;
    }
    myGrid.attachFooter(htmls, ["text-align:left;"]);
    myGrid.changBoxHeight(-20);
    if ("hideCount" === flagId) {
        $(`#${this.gridId}_${flagId}`)
            .closest("tr")
            .hide();
    }
};
//改变grid的box的高度
dhtmlXGridObject.prototype.changBoxHeight = function (height) {
    let myGrid = this;
    let oldHeight = $(`#${myGrid.gridId} .objbox`).height();
    $(`#${myGrid.gridId} .objbox`).css(
        "height",
        parseFloat(oldHeight + "") + height
    );
};

//删除底部工具栏
dhtmlXGridObject.prototype.closeFooterBar = function (flagId) {
    let myGrid = this;
    $(`#${myGrid.gridId}_${flagId}`)
        .closest("tr")
        .remove();
    myGrid.changBoxHeight(20);
};

//根据列名称 和 列的值查找一行的值
dhtmlXGridObject.prototype.findRowRecordByCol = function (
    colName,
    colValue
) {
    var gridObj = this;
    var ids = gridObj
        .getAllRowIds(GoingUtils.relChart)
        .split(GoingUtils.relChart);
    for (var num = 0; num < ids.length; num++) {
        let rowValues = gridObj.getRowRecord(ids[num]);
        rowValues["id"] = ids[num];
        if (rowValues != null && colValue === rowValues[colName]) {
            return rowValues;
        }
    }
    return null;
};

//设置单元格的值
dhtmlXGridObject.prototype.setCellValue = function (
    rowId,
    colName,
    colValue
) {
    var colIndex = this.getColIndexByField(colName);
    if (colName === "colSelBox") {
        if (this.colSelBox && this.colOrderNum) {
            colIndex = 1;
        }
        if (this.colSelBox && !this.colOrderNum) {
            colIndex = 0;
        }
    }
    if (AssertUtils.isNotEmpty(rowId)) {
        var cellObj = this.cells(rowId, colIndex);
        cellObj.setValue(colValue);
    }
};
/**
 * 循环选中的记录集合 执行一个指定函数
 * @param fun
 */
dhtmlXGridObject.prototype.forEachSelectedRow = function (fun) {
    var selIds = this.getSelectedRowIds();
    var idsAry = selIds.split(GoingUtils.relChart);
    $.each(idsAry, function (key, val) {
        fun(val);
    });
};
/**
 * 核一条记录的某列必须是相应状态下的 才能进行操作
 * grid.checkRecord('修改','state','待审核')
 * 核对 只有字段state值为待审核的状态 才可以进行操作
 * @param operationMsg
 * @param propName
 * @param propVal
 * @returns {boolean}
 */
dhtmlXGridObject.prototype.checkRecord = function (
    operationMsg,
    propName,
    propVal
) {
    var gridObj = this;
    var selIdAry = gridObj.getSelectedRowIds("array");
    if (selIdAry.length > 1) {
        GoingUtils.showErrorMessage("请只选择一条记录进行操作");
        return false;
    }
    var selId = gridObj.getSelectedRowId();
    if (AssertUtils.isNotEmpty(selId)) {
        if (AssertUtils.isArray(propVal)) {
            var paperStatus = gridObj.getCellValue(selId, propName);
            if (!ArrayUtils.aryContains(propVal, paperStatus)) {
                GoingUtils.showErrorMessage(
                    "不是" +
                    propVal.join(";") +
                    "状态的记录无法进行" +
                    operationMsg +
                    "操作"
                );
                return false;
            }
        } else {
            if (AssertUtils.isNotEmpty(propVal)) {
                let paperStatus = gridObj.getCellValue(selId, propName);
                if (paperStatus != propVal) {
                    GoingUtils.showErrorMessage(
                        "不是" + propVal + "状态的记录无法进行" + operationMsg + "操作"
                    );
                    return false;
                }
                return true;
            }
        }
        return true;
    } else {
        GoingUtils.showErrorMessage("请选择相应的记录后再操作");
        return false;
    }
};
/**
 * 核一批记录的某列必须是相应状态下的 才能进行操作
 * grid.checkRecord('修改','state','待审核')
 * 核对 只有字段state值为待审核的状态 才可以进行操作
 * @param operationMsg
 * @param propName
 * @param propVal
 * @returns {boolean}
 */
dhtmlXGridObject.prototype.checkRecords = function (
    operationMsg,
    propName,
    propVal
) {
    var gridObj = this;
    var selIdAry = gridObj.getSelectedRowIds("array");
    if (AssertUtils.isNotEmpty(selIdAry.join(";"))) {
        if (AssertUtils.isArray(propVal)) {
            for (var num = 0; num < selIdAry.length; num++) {
                let selId = selIdAry[num];
                let paperStatus = gridObj.getCellValue(selId, propName);
                if (!ArrayUtils.aryContains(propVal, paperStatus)) {
                    GoingUtils.showErrorMessage(
                        "不是" +
                        propVal.join(";") +
                        "状态的记录无法进行" +
                        operationMsg +
                        "操作"
                    );
                    return false;
                }
            }
        } else {
            if (AssertUtils.isNotEmpty(propVal)) {
                for (var nums = 0; nums < selIdAry.length; nums++) {
                    let selIdT = selIdAry[nums];
                    let paperStatusT = gridObj.getCellValue(selIdT, propName);
                    if (paperStatusT != propVal) {
                        GoingUtils.showErrorMessage(
                            "不是" + propVal + "状态的记录无法进行" + operationMsg + "操作"
                        );
                        return false;
                    }
                }
                return true;
            }
        }
        return true;
    } else {
        GoingUtils.showErrorMessage("请选择相应的记录后再操作");
        return false;
    }
};

/**
 * 获取表格某个单元格的值
 * @param rowId 行id  也可以是一批行id拼接的字符串
 * @param cellName 列名称
 * @returns {string}
 */
dhtmlXGridObject.prototype.getCellValue = function (
    rowId,
    cellName
) {
    let cellValues = new Array();
    if ((rowId+"").indexOf(GoingUtils.relChart) > 0) {
        let idsAry = rowId.split(GoingUtils.relChart);
        for (let num = 0; num < idsAry.length; num++) {
            cellValues.push(this.getCellValue(idsAry[num], cellName));
        }
    } else {
        cellValues.push(this.getCellValueBySingle(rowId, cellName));
    }
    return cellValues.join(GoingUtils.relChart);
};
/**
 * 获取表格某个单元格的值
 * @param rowId 行id
 * @param cellName 列名称
 * @returns {string}
 */
dhtmlXGridObject.prototype.getCellValueBySingle = function (rowId, cellName) {
    if (!AssertUtils.isNumber(cellName)) {
        cellName = this.getColIndexByField(cellName);
    }
    let cellValue = "";
    // try {
    //cells2表示根据 行序号来获取其中的值
    try{
        cellValue = this.cells(rowId, cellName)&&this.cells(rowId, cellName).getValue();
    }catch (e) {
        cellValue = this.cells2(rowId, cellName)&&this.cells2(rowId, cellName).getValue();
    }
    return cellValue;
}
;

function getBooleanByInt(state) {
    if (state == 0) {
        state = true;
    } else {
        state = false;
    }
    return state;
}

/**
 * 根据传入的rowId  将某行设置为选中状态
 * @param rowId
 */
dhtmlXGridObject.prototype.setRowIsSelected = function (rowId) {
    if (this.colSelBox) {
        let cellObj = this.cells(rowId, this.getSelectColInd());
        let state = cellObj.getValue();
        state = getBooleanByInt(state);
        cellObj.setValue(state);
        gridCommonEvent.doOnCheck(this, rowId, this.getSelectColInd(), state);
    }
};
/**
 * 根据列名称 判断是否存在某列数据
 * @param colName
 * @returns {boolean}
 */
dhtmlXGridObject.prototype.hasColumn = function (colName) {
    let colIndex = this.getColIndexByField(colName);
    if (colIndex >= 0) {
        return true;
    }
    return false;
};
/**
 * 获取一行数据 根据行id
 * @param row
 * @returns {*}
 */
dhtmlXGridObject.prototype.getRowRecord = function (
    row,
    backType = "json"
) {
    //如果为空 则取选中行的数据
    if (!AssertUtils.isNotNull(row)) {
        row = this.getSelectedRowId();
    }
    let record = new Record();
    if (backType === "json") {
        (record) = {};
    }
    //判断是否存在selBox 如果存在选择列
    if (this.colSelBox) {
        if (backType === "json") {
            (record)["selBox"] = this.getCellValue(this.getRowIndex(row), 1);
        } else {
            (record).setValue(
                "selBox",
                this.getCellValue(this.getRowIndex(row), 1)
            );
        }
    }
    for (var num = 0; num < this.queryFieldAry.length; num++) {
        if (this.queryFieldAry[num] === "id") {
            continue;
        }
        if (backType === "json") {
            (record)[this.queryFieldAry[num]] = this.getCellValue(
                this.getRowIndex(row),
                this.getColIndexByField(this.queryFieldAry[num])
            );
        } else {
            record.setValue(
                this.queryFieldAry[num],
                this.getCellValue(
                    this.getRowIndex(row),
                    this.getColIndexByField(this.queryFieldAry[num])
                )
            );
        }
    }
    if (backType === "json") {
        (record)["id"] = row;
    } else {
        record.setValue("id", row);
    }
    return record;
};


class eXcell_date10_ro extends eXcell_edn {
    constructor(cell) {
        super();
        this.base = eXcell_edn;
        this.base(cell);
    }

    getValue() {
        return this.cell.innerText;
    }

    isDisabled() {
        return true;
    }

    edit() {
        return false;
    }
}

eXcell_date10_ro.prototype.setValue = function (val) {
    if (val != null && val != "") {
        this.cell.innerHTML = this.grid._aplNF(DateFun.formatDateString(val, "yyyy-MM-dd"), this.cell._cellIndex);
    } else {
        this.cell.innerHTML = this.grid._aplNF("", this.cell._cellIndex);
    }
};
window.eXcell_date10_ro = eXcell_date10_ro;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/extend/dxGridExtend.js